import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import ScrollToTop from '../ScrollToTop';
import ViewRecorder from '../ViewRecorder';

const Layout = ({ children }) => (
  <>
    <ViewRecorder />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <ScrollToTop />
  </>
);

export default Layout;
